import { getAreaCategoriesForSeatLayout, getScreenById, getSeatAvailabilityForShowtime, getSeatLayoutById, getShowtimeById } from '@vista/omnichannel-components-domain';
export const getSeatSelectionLimitsForReservedSeats = (areaCategoryIds, reservedSeats) => {
    const limitsPerAreaCategory = {};
    areaCategoryIds.forEach(areaCategoryId => {
        const seatCount = reservedSeats.filter(seat => seat.areaCategoryId === areaCategoryId).length;
        limitsPerAreaCategory[areaCategoryId] = { min: seatCount, max: seatCount };
    });
    return {
        min: reservedSeats.length,
        max: reservedSeats.length,
        limitsPerAreaCategory
    };
};
export const getSeatingDataForShowtime = (showtimeId, friendSeatIds, reservedSeats) => {
    const showtime = getShowtimeById(showtimeId);
    if (!showtime)
        return; // Showtime still loading
    if (!showtime.isAllocatedSeating) {
        throw new Error(`Cannot render Swap Seat Picker for unallocated showtime ${showtimeId}.`);
    }
    const { screenId, seatLayoutId, siteId } = showtime;
    const screen = getScreenById(screenId);
    if (!screen)
        throw new Error(`Cannot find screen with ID: ${screenId}.`);
    const seatLayout = getSeatLayoutById(seatLayoutId);
    const seatAvailability = getSeatAvailabilityForShowtime(showtimeId);
    if (!seatLayout || !seatAvailability || !reservedSeats)
        return; // Data still loading
    const areaCategories = getAreaCategoriesForSeatLayout(seatLayoutId);
    const seatSelectionLimits = getSeatSelectionLimitsForReservedSeats(areaCategories.map(ac => ac.id), reservedSeats);
    return {
        areaCategories,
        reservedSeatIds: reservedSeats.map(seat => seat.seatId),
        friendSeatIds,
        screen,
        seatAvailabilities: seatAvailability.seatAvailabilities,
        seatLayout,
        seatSelectionLimits,
        siteId
    };
};
